import { render, staticRenderFns } from "./UPD2.vue?vue&type=template&id=390c3160&scoped=true&"
import script from "./UPD2.vue?vue&type=script&lang=js&"
export * from "./UPD2.vue?vue&type=script&lang=js&"
import style0 from "./UPD2.vue?vue&type=style&index=0&id=390c3160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390c3160",
  null
  
)

export default component.exports